/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `unseren Newsletter`
};

const en_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `our Newsletter`
};

const es_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `nuestro boletín`
};

const fr_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `notre Newsletter`
};

const it_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `la nostra newsletter`
};

const nl_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `onze nieuwsbrief`
};

const pt_launchpad__account_modal_newsletter = /** @type {(inputs: {}) => string} */ () => {
	return `nossa Newsletter`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_newsletter = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.launchpad__account_modal_newsletter(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("launchpad__account_modal_newsletter", locale)
	if (locale === "de") return de_launchpad__account_modal_newsletter(inputs)
	if (locale === "en") return en_launchpad__account_modal_newsletter(inputs)
	if (locale === "es") return es_launchpad__account_modal_newsletter(inputs)
	if (locale === "fr") return fr_launchpad__account_modal_newsletter(inputs)
	if (locale === "it") return it_launchpad__account_modal_newsletter(inputs)
	if (locale === "nl") return nl_launchpad__account_modal_newsletter(inputs)
	return pt_launchpad__account_modal_newsletter(inputs)
};